import 'babel-polyfill';
import 'es6-promise/auto';

import Vue from 'vue'
import store from './store/index';
import router from './router/index';
import Loading from 'vue-loading-overlay';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCaretDown, faCaretRight, faBars, faCog, faSearch,
  faCalendarAlt, faUserMd, faPlaneDeparture, faFile, faCalendarCheck,
  faFilter, faSortAmountUp, faPlusCircle, faMinusCircle, faTimesCircle,
  faCheckSquare, faTimes, faCheck, faSave, faEye, faTrash, faCrop, faQuestionCircle,
  faSearchPlus, faFilePdf, faFileMedical, faFileMedicalAlt, faFileAlt, faMapMarkerAlt,
  faPhone, faEnvelope, faBuilding, faFax, faSpinner, faThumbtack,
  faArrowRight, faAngleDoubleLeft, faAngleDoubleRight, faPrescriptionBottle,
  faAngleLeft, faAngleRight, faInbox, faNotesMedical, faPen, faBan, faStar, faAddressBook, faPencilAlt,
  faComment
} from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Calendar from 'v-calendar/lib/components/calendar.umd'
import 'bootstrap/dist/css/bootstrap.css';
import './stylesheets/keyon.scss';
import 'vue-loading-overlay/dist/vue-loading.css';
import './stylesheets/style.scss';
import TextHighlight from 'vue-text-highlight';
// import VScrollToTop from 'v-scroll-to-top'
import App from './App.vue';
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import VueSweetalert2 from 'vue-sweetalert2';
import { FsmStart } from './store/modules/fsm/messages';
import { post } from './store/modules/fsm/index';
import VueSimpleContextMenu from 'vue-simple-context-menu';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import PrimeVue from 'primevue/config';
import PickList from 'primevue/picklist';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab'
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

// register component to use
Vue.config.productionTip = false;
Vue.component('v-calendar', Calendar)
Vue.component('text-highlight', TextHighlight);
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-chart', ECharts)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
Vue.use(router);
Vue.use(Loading,{
  color:'blue'
});
Vue.use(VueSweetalert2);
Vue.use(PrimeVue);
Vue.component('PickList', PickList);
Vue.component('Accordion', Accordion)
Vue.component('AccordionTab', AccordionTab)

library.add(faCaretDown, faBars, faCog, faSearch, faCalendarAlt,
  faCaretRight, faUserMd, faPlaneDeparture, faFile, faCalendarCheck,
  faFilter, faSortAmountUp, faPlusCircle, faMinusCircle, faTimesCircle,
  faCheckSquare, faTimes, faCheck, faSave, faEye, faTrash, faCrop, faQuestionCircle,
  faSearchPlus, faFilePdf, faFileMedical, faFileMedicalAlt, faFileAlt, faMapMarkerAlt,
  faPhone, faEnvelope, faBuilding, faFax, faArrowRight, faAngleDoubleLeft, faPrescriptionBottle,
  faAngleDoubleRight, faAngleLeft, faAngleRight, faInbox, faUserMd, faNotesMedical, faThumbtack,
  faPen, faBan, faStar, faAddressBook, faPencilAlt, faSpinner, faComment);

window.store = store;
// define global event bus
Vue.vueEventBus = Vue.prototype.$vueEventBus = new Vue();
Vue.sessionTimer = Vue.prototype.$sessionTimer = null;
Vue.gotInitialMessage = false;
Vue.prototype.$gotInitialMessage = () => Vue.gotInitialMessage ? true : false;

post({ message: FsmStart });

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
});
